<footer class="footer">
  <div class="footer-content">
    <h1>Contact</h1>
    <div>
      <div>
        <h3>Het Raaymakers Antiek & Interieur</h3>
        <span>Kerkeind 44</span>
        <span>5763 BD Milheeze</span>
        <span class="phone">T. 0492-342013</span>
        <span>F. 0492-343695</span>
        <span>info&#64;hetraaymakersantiek.nl</span>
      </div>
      <div>
        <h3>Openingstijden</h3>
        <span>Woensdag t/m Zaterdag</span>
        <span>10:00 tot 17:00 uur of na</span>
        <span>telefonische afspraak.</span>
      </div>
      <div>
        <h3>Volg ons op</h3>
        <div class="social-icons">
          <a href="#"><i class="pi pi-facebook"></i></a>
          <a href="#"><i class="pi pi-instagram"></i></a>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="footer-bottom-content">
      <span>&copy; {{ getCurrentYear() }} Het Raaymakers Antiek & Interieur</span>
      <span>|</span>
      <span><a routerLink="/algemene-voorwaarden">Algemene voorwaarden</a></span>
    </div>
  </div>
</footer>
